import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Menu,
  MenuItem,
  Avatar,

} from '@mui/material';
import {
  Menu as MenuIcon,
  Dashboard,
  People,
  AdminPanelSettings,
  TimeToLeave,
  Payment,
  Work,
  Assessment,
  AccountCircle,

  CalendarMonth,
  AccountTree,
  ChecklistRtl,
  BarChart as BarChartIcon,
  FolderOpen,
  FlightTakeoff,
  ExitToApp,
  School,
  Inventory2,
  Description,
  Receipt,
  AccountBalance,
  Assignment,
  CreditScore,
  Tune,
  TrendingDown,
  TrendingUp,
  Insights,
  PostAdd,
  Diversity3,
  TrackChanges,
  FavoriteBorder,
  EmojiEvents,
  QueryStats,
  Poll,
  Campaign,
  HomeWork,
  SupportAgent,
  MeetingRoom as MeetingRoomIcon,
  Fingerprint,
  MoreTime,
  Policy as PolicyIcon,
  HealthAndSafety,
  Groups,
  Gavel,
  Contacts,
  BeachAccess,
  EditCalendar,
  Savings,
  Report,
  ContactEmergency,
  SwapHoriz,
  ReceiptLong,
  EventRepeat,
  CompareArrows,
  AttachMoney,
  CalendarToday,
  StickyNote2,
  Schema,
  MenuBook,
  DisplaySettings,
  AccessTime,
  TransferWithinAStation,
  Shield,
  Article,
  Balance,
  EventBusy,
  ModelTraining,
  Grid3x3,
  PersonOff,
  Dangerous,
  Leaderboard,
  Cake,
  Inbox,
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import ChangePasswordModal from '../ChangePasswordModal';
import GlobalSearch from '../GlobalSearch';

const drawerWidth = 224; // w-56 (BRAND §5)

const menuItems = [
  { text: 'Dashboard', path: '/', icon: <Dashboard />, roles: ['hr_admin', 'employee'] },
  { text: 'HR Inbox', path: '/hr-inbox', icon: <Inbox />, roles: ['hr_admin', 'hr_manager'] },
  { text: 'Employees', path: '/employees', icon: <People />, roles: ['hr_admin'] },
  { text: 'Directory', path: '/directory', icon: <Contacts />, roles: ['hr_admin', 'hr_manager', 'manager', 'employee', 'recruiter', 'finance'] },
  { text: 'Roster', path: '/roster', icon: <CalendarMonth />, roles: ['hr_admin', 'hr_manager', 'manager'] },
  { text: 'Att. Corrections', path: '/attendance-corrections', icon: <EditCalendar />, roles: ['hr_admin', 'hr_manager', 'manager', 'employee'] },
  { text: 'Leave Encashment', path: '/leave-encashment', icon: <Savings />, roles: ['hr_admin', 'hr_manager', 'finance', 'employee'] },
  { text: 'Shift Swaps', path: '/shift-swaps', icon: <SwapHoriz />, roles: ['hr_admin', 'hr_manager', 'manager', 'employee'] },
  { text: 'Expense Reports', path: '/expense-reports', icon: <ReceiptLong />, roles: ['hr_admin', 'hr_manager', 'finance', 'manager', 'employee'] },
  { text: 'Leave Carryover', path: '/leave-carryover', icon: <EventRepeat />, roles: ['hr_admin', 'hr_manager'] },
  { text: 'Leave Balance Report', path: '/leave-balance-report', icon: <BeachAccess />, roles: ['hr_admin', 'hr_manager'] },
  { text: 'Payroll Variance', path: '/payroll-variance', icon: <CompareArrows />, roles: ['hr_admin', 'hr_manager', 'finance'] },
  { text: 'Labour Cost', path: '/labour-cost', icon: <AttachMoney />, roles: ['hr_admin', 'hr_manager', 'finance'] },
  { text: 'Employee Notes', path: '/employee-notes', icon: <StickyNote2 />, roles: ['hr_admin', 'hr_manager', 'manager'] },
  { text: 'Succession Pipeline', path: '/succession-pipeline', icon: <Schema />, roles: ['hr_admin', 'hr_manager'] },
  { text: 'HR Calendar', path: '/hr-calendar', icon: <CalendarToday />, roles: ['hr_admin', 'hr_manager', 'manager'] },
  { text: 'Emergency Contacts', path: '/emergency-contacts', icon: <ContactEmergency />, roles: ['hr_admin', 'hr_manager', 'manager', 'employee'] },
  { text: 'Leave Management', path: '/employees/leave', icon: <TimeToLeave />, roles: ['hr_admin'] },
  { text: 'Leave Management', path: '/leave', icon: <TimeToLeave />, roles: ['employee'] },
  { text: 'Payroll', path: '/payroll', icon: <Payment />, roles: ['hr_admin', 'employee'] },
  { text: 'Recruitment', path: '/recruitment', icon: <Work />, roles: ['hr_admin', 'approver'] },
  { text: 'Performance', path: '/performance', icon: <Assessment />, roles: ['hr_admin'] },
  { text: 'Probation Tracker', path: '/probation-tracker', icon: <Assessment />, roles: ['hr_admin', 'hr_manager', 'manager'] },
  { text: 'Onboarding', path: '/onboarding', icon: <ChecklistRtl />, roles: ['hr_admin'] },
  { text: 'Offboarding', path: '/offboarding', icon: <ExitToApp />, roles: ['hr_admin'] },
  { text: 'Training ROI', path: '/training-roi', icon: <ModelTraining />, roles: ['hr_admin', 'hr_manager', 'finance'] },
  { text: 'Turnover Risk', path: '/turnover-risk', icon: <PersonOff />, roles: ['hr_admin', 'hr_manager'] },
  { text: 'Org Risk Heat Map', path: '/org-risk', icon: <Dangerous />, roles: ['hr_admin', 'hr_manager'] },
  { text: 'Executive Dashboard', path: '/executive-dashboard', icon: <Leaderboard />, roles: ['hr_admin', 'hr_manager', 'finance'] },
  { text: 'Career Paths', path: '/career', icon: <TrendingUp />, roles: ['hr_admin', 'hr_manager', 'manager', 'employee'] },
  { text: 'Goals & OKRs', path: '/goals', icon: <TrackChanges />, roles: ['hr_admin', 'hr_manager', 'manager', 'employee', 'finance'] },
  { text: 'Workforce Analytics', path: '/workforce-analytics', icon: <QueryStats />, roles: ['hr_admin', 'hr_manager', 'finance'] },
  { text: 'Milestones', path: '/milestones', icon: <Cake />, roles: ['hr_admin', 'hr_manager', 'manager'] },
  { text: 'Attendance', path: '/attendance', icon: <Fingerprint />, roles: ['hr_admin', 'hr_manager', 'manager', 'employee', 'recruiter', 'finance'] },
  { text: 'Attendance Report', path: '/attendance-report', icon: <AccessTime />, roles: ['hr_admin', 'hr_manager', 'manager'] },
  { text: 'Overtime', path: '/overtime', icon: <MoreTime />, roles: ['hr_admin', 'hr_manager', 'manager', 'employee', 'recruiter', 'finance'] },
  { text: 'TOIL Bank', path: '/toil', icon: <AccessTime />, roles: ['hr_admin', 'hr_manager', 'manager', 'employee', 'recruiter', 'finance'] },
  { text: 'Approval Delegation', path: '/delegation', icon: <SwapHoriz />, roles: ['hr_admin', 'hr_manager', 'manager', 'employee', 'recruiter', 'finance'] },
  { text: 'Org Changes', path: '/org-changes', icon: <TransferWithinAStation />, roles: ['hr_admin', 'hr_manager', 'manager'] },
  { text: 'Salary History', path: '/salary-history', icon: <AttachMoney />, roles: ['hr_admin', 'hr_manager', 'finance', 'employee'] },
  { text: 'Salary Review Planner', path: '/salary-review', icon: <TrendingUp />, roles: ['hr_admin', 'hr_manager', 'finance'] },
  { text: 'My Team Dashboard', path: '/manager-dashboard', icon: <Dashboard />, roles: ['manager'] },
  { text: 'Compliance Docs', path: '/compliance-docs', icon: <Shield />, roles: ['hr_admin', 'hr_manager', 'employee'] },
  { text: 'JD Templates', path: '/jd-templates', icon: <Description />, roles: ['hr_admin', 'hr_manager', 'manager', 'recruiter'] },
  { text: 'Notice Period', path: '/notice-period', icon: <ExitToApp />, roles: ['hr_admin', 'hr_manager', 'manager'] },
  { text: 'Letter Templates', path: '/letter-templates', icon: <Article />, roles: ['hr_admin', 'hr_manager', 'employee'] },
  { text: 'Pay Equity', path: '/pay-equity', icon: <Balance />, roles: ['hr_admin', 'hr_manager', 'finance'] },
  { text: 'Pre-Boarding', path: '/pre-boarding', icon: <FlightTakeoff />, roles: ['hr_admin', 'hr_manager'] },
  { text: 'Manpower Report', path: '/manpower-report', icon: <Assessment />, roles: ['hr_admin', 'hr_manager', 'finance'] },
  { text: 'Absence Register', path: '/absence', icon: <EventBusy />, roles: ['hr_admin', 'hr_manager', 'manager', 'employee'] },
  { text: 'Leave Policy Admin', path: '/leave-policy-admin', icon: <PolicyIcon />, roles: ['hr_admin', 'hr_manager'] },
  { text: 'Exit Interviews', path: '/exit-interviews', icon: <ExitToApp />, roles: ['hr_admin', 'hr_manager'] },
  { text: 'Policies', path: '/policies', icon: <PolicyIcon />, roles: ['hr_admin', 'hr_manager', 'manager', 'employee', 'recruiter', 'finance'] },
  { text: 'Company Settings', path: '/company-settings', icon: <DisplaySettings />, roles: ['hr_admin'] },
  { text: 'Benefits', path: '/benefits', icon: <HealthAndSafety />, roles: ['hr_admin', 'hr_manager', 'manager', 'employee', 'recruiter', 'finance'] },
  { text: 'Payslips', path: '/payslips', icon: <Receipt />, roles: ['hr_admin', 'hr_manager', 'manager', 'employee', 'recruiter', 'finance'] },
  { text: 'Headcount', path: '/headcount', icon: <Groups />, roles: ['hr_admin', 'hr_manager', 'manager', 'finance'] },
  { text: 'Disciplinary', path: '/disciplinary', icon: <Gavel />, roles: ['hr_admin', 'hr_manager'] },
  { text: 'Public Holidays', path: '/public-holidays', icon: <BeachAccess />, roles: ['hr_admin', 'hr_manager', 'manager', 'employee', 'recruiter', 'finance'] },
  { text: 'Work From Home', path: '/wfh', icon: <HomeWork />, roles: ['hr_admin', 'hr_manager', 'manager', 'employee', 'recruiter', 'finance'] },
  { text: 'Assets', path: '/assets', icon: <Inventory2 />, roles: ['hr_admin'] },
  { text: 'Contracts', path: '/contracts', icon: <Description />, roles: ['hr_admin'] },
  { text: 'Expenses', path: '/expenses', icon: <Receipt />, roles: ['hr_admin', 'hr_manager', 'manager', 'employee', 'approver', 'recruiter', 'finance'] },
  { text: 'IR56B Tax Filing', path: '/ir56b', icon: <Assignment />, roles: ['hr_admin', 'hr_manager', 'finance'] },
  { text: 'Perf Calibration', path: '/calibration', icon: <Tune />, roles: ['hr_admin', 'hr_manager'] },
  { text: 'PIPs', path: '/pip', icon: <TrendingDown />, roles: ['hr_admin', 'hr_manager', 'manager', 'employee'] },
  { text: 'Bank File', path: '/bank-file', icon: <CreditScore />, roles: ['hr_admin', 'hr_manager', 'finance'] },
  { text: 'Business Trips', icon: <FlightTakeoff />, path: '/business-trips', roles: ['hr_admin', 'hr_manager', 'manager', 'employee', 'recruiter', 'finance'] },

  { text: 'Org Chart', path: '/org-chart', icon: <AccountTree />, roles: ['hr_admin', 'employee'] },
  { text: 'Reports', path: '/reports', icon: <BarChartIcon />, roles: ['hr_admin'] },
  { text: 'Admin', path: '/admin', icon: <AdminPanelSettings />, roles: ['hr_admin'] },
];

const Layout: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
    handleMenuClose();
    navigate('/login');
  };

  const handleChangePassword = () => {
    setChangePasswordOpen(true);
    handleMenuClose();
  };

  const handlePasswordChanged = () => {
    // Could show a success message or redirect
    console.log('Password changed successfully');
  };



  const drawer = (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', background: 'rgba(255,255,255,0.6)' }}>
      <Toolbar sx={{ minHeight: '70px !important', borderBottom: '1px solid #E5E2DA', alignItems: 'center' }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Box>
            {/* gold small-caps eyebrow naming the suite area */}
            <Typography
              sx={{
                color: '#C08A2E',
                fontSize: '10px',
                fontWeight: 600,
                textTransform: 'uppercase',
                letterSpacing: '0.2em',
                fontVariant: 'small-caps',
                lineHeight: 1.4,
              }}
            >
              People
            </Typography>
            <Typography
              variant="subtitle1"
              noWrap
              sx={{ fontFamily: '"Space Grotesk", sans-serif', color: '#16223B', fontWeight: 600, letterSpacing: '-0.02em', lineHeight: 1.2 }}
            >
              HRIS
            </Typography>
          </Box>
        </Box>
      </Toolbar>
      <Box sx={{ p: 1.5, flex: 1, overflowY: 'auto' }}>
      <List dense>
        {menuItems
          .filter((item) => {
            if (!user?.role) return false;
            if (item.roles.includes(user.role)) return true;
            if (user.employee?.access === 'approver' && item.roles.includes('approver')) return true;
            return false;
          })
          .map((item) => {
            const selected = location.pathname === item.path;
            return (
            <ListItem key={item.text} disablePadding sx={{ mb: 0.25 }}>
                <ListItemButton
                  selected={selected}
                  onClick={() => navigate(item.path)}
                  sx={{
                    borderRadius: 1.5,
                    color: 'rgba(22,34,59,0.7)',
                    '& .MuiListItemIcon-root': { color: 'rgba(22,34,59,0.55)' },
                    '&.Mui-selected': {
                      bgcolor: '#F3E6CD',
                      color: '#16223B',
                      '& .MuiListItemText-primary': { fontWeight: 600 },
                      '& .MuiListItemIcon-root': { color: '#16223B' },
                      '&:hover': { bgcolor: '#F3E6CD' },
                    },
                    '&:hover': { bgcolor: 'rgba(229,226,218,0.4)', color: '#16223B' },
                  }}
                >
                  {/* gold tick on active item, transparent otherwise */}
                  <Box
                    sx={{
                      width: '2px',
                      height: 16,
                      borderRadius: 9999,
                      mr: 1,
                      bgcolor: selected ? '#C08A2E' : 'transparent',
                      flexShrink: 0,
                    }}
                  />
                  <ListItemIcon sx={{ minWidth: 36 }}>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} primaryTypographyProps={{ fontSize: '0.875rem', fontWeight: 500 }} />
                </ListItemButton>
              </ListItem>
            );
          })}
      </List>
      </Box>
    </div>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          backgroundColor: '#FFFFFF',
          color: '#16223B',
          boxShadow: 'none',
          borderBottom: '1px solid #E5E2DA',
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <GlobalSearch />
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="body1" sx={{ mr: 2 }}>
              {user?.employee?.nickname} {user?.employee?.lastName}
            </Typography>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenuClick}
              color="inherit"
            >
              <Avatar sx={{ bgcolor: 'secondary.main' }}>
                <AccountCircle />
              </Avatar>
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={() => { handleMenuClose(); navigate('/profile'); }}>Profile</MenuItem>
              <MenuItem onClick={handleChangePassword}>Change Password</MenuItem>
              <MenuItem onClick={handleMenuClose}>Settings</MenuItem>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders"
      >
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, borderRight: '1px solid #E5E2DA', boxShadow: 'none' },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, borderRight: '1px solid #E5E2DA', boxShadow: 'none' },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` }, bgcolor: '#F7F6F2', minHeight: '100vh' }}
      >
        <Toolbar />
        <Outlet />
      </Box>
      
      {/* Change Password Modal */}
      <ChangePasswordModal
        open={changePasswordOpen}
        onClose={() => setChangePasswordOpen(false)}
        onPasswordChanged={handlePasswordChanged}
      />
    </Box>
  );
};

export default Layout;